import { NavLink, Outlet, useNavigate } from 'react-router-dom';
import { clsx } from 'clsx';
import { useAuth } from '../lib/auth';
import { ThemeToggle } from './ThemeToggle';

const NAV_ITEMS: { to: string; label: string; perm?: string; adminOnly?: boolean }[] = [
  { to: '/', label: 'Panel' },
  { to: '/agent', label: 'KYS Agent' },
  { to: '/reports', label: 'Raporlar', perm: 'report.create' },
  { to: '/capa', label: 'CAPA' },
  { to: '/audit', label: 'Tetkik' },
  { to: '/ygg', label: 'YGG' },
  { to: '/registry', label: 'Dokümanlar' },
  { to: '/users', label: 'Kullanıcılar', adminOnly: true },
];

const ROLE_LABEL: Record<string, string> = {
  ADMIN: 'Yönetici',
  QA_MANAGER: 'KYT',
  AUDITOR: 'Tetkikçi',
  READ_ONLY: 'Görüntüleyici',
};

export function Layout() {
  const { user, logout, hasPermission } = useAuth();
  const navigate = useNavigate();

  return (
    <div className="flex h-full min-h-screen">
      <aside className="hidden w-64 shrink-0 flex-col border-r border-slate-200 bg-white md:flex dark:border-slate-800 dark:bg-slate-900">
        <div className="border-b border-slate-200 px-6 py-5 dark:border-slate-800">
          <div className="text-xs font-semibold uppercase tracking-wider text-brand-600 dark:text-brand-400">
            SE Havacılık
          </div>
          <div className="mt-1 text-sm font-medium text-slate-900 dark:text-slate-100">
            AS9100D Kalite
          </div>
          <div className="mt-0.5 text-xs text-slate-500 dark:text-slate-400">
            KYS Rev.00 — 05.05.2025
          </div>
        </div>
        <nav className="flex-1 space-y-1 px-3 py-4">
          {NAV_ITEMS.filter((i) => {
            if (i.adminOnly && user?.role !== 'ADMIN') return false;
            if (i.perm && !hasPermission(i.perm)) return false;
            return true;
          }).map((i) => (
            <NavLink
              key={i.to}
              to={i.to}
              end={i.to === '/'}
              className={({ isActive }) =>
                clsx(
                  'block rounded-md px-3 py-2 text-sm font-medium transition',
                  isActive
                    ? 'bg-brand-50 text-brand-700 dark:bg-brand-900/40 dark:text-brand-200'
                    : 'text-slate-600 hover:bg-slate-50 hover:text-slate-900 dark:text-slate-300 dark:hover:bg-slate-800 dark:hover:text-slate-100',
                )
              }
            >
              {i.label}
            </NavLink>
          ))}
        </nav>
        <div className="space-y-3 border-t border-slate-200 px-4 py-3 dark:border-slate-800">
          {user && (
            <div>
              <div className="text-sm font-medium text-slate-900 dark:text-slate-100">
                {user.name}
              </div>
              <div className="text-xs text-slate-500 dark:text-slate-400">{user.email}</div>
              <div className="mt-1">
                <span className="badge bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300">
                  {ROLE_LABEL[user.role]}
                </span>
              </div>
            </div>
          )}
          <div className="flex items-center justify-between">
            <span className="text-xs text-slate-500 dark:text-slate-400">Tema</span>
            <ThemeToggle />
          </div>
          <button
            type="button"
            className="btn-secondary w-full justify-center"
            onClick={() => {
              logout();
              navigate('/login');
            }}
          >
            Çıkış
          </button>
        </div>
      </aside>

      <main className="flex-1 overflow-y-auto bg-slate-50 dark:bg-slate-950">
        <header className="flex items-center justify-between border-b border-slate-200 bg-white px-6 py-3 md:hidden dark:border-slate-800 dark:bg-slate-900">
          <div className="text-sm font-semibold text-brand-700 dark:text-brand-300">
            SE Havacılık — AS9100 QA
          </div>
          <ThemeToggle />
        </header>
        <div className="mx-auto max-w-7xl px-4 py-6 sm:px-6 lg:px-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
}
